import { useQuery } from '@tanstack/react-query';
import { makeDashboardApi } from '../DashboardApi';
import { AxiosError, AxiosResponse } from 'axios';
import { ISalesMetricsRequest, ISalesMetricsResponse } from '../types';

export const useSalesMetrics = (request: ISalesMetricsRequest) => {
  const salesMetrics = useQuery<AxiosResponse<ISalesMetricsResponse>, AxiosError>({
    queryKey: ['sales-metrics', request],
    queryFn: () => {
      return makeDashboardApi().getSalesMetrics(request);
    },
    retry: false,
  });

  return {
    salesMetricsData: salesMetrics.data?.data,
    isLoadingSalesMetricsData: salesMetrics.isLoading,
    isErrorSalesMetricsData: salesMetrics.isError,
  };
};
